import { ApiError, Entitlement } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { fetchSubscriptionSuccess, UserAction, UserActionTypes } from "../User";
import { concatMap } from "rxjs";
import { amazonSubscribe as apiAmazonSubscribe } from "@blacknut/javascript-sdk/dist/api/User/Action/amazonSubscribe";
import { getEntitlements } from "@blacknut/javascript-sdk/dist/api/BlacknutPlus/getEntitlements";
import { ThunkDispatchType } from "core/redux/Store";

const userAmazonSubscribeRequest = (): UserAction => ({
  type: UserActionTypes.USER_AMAZON_SUBSCRIBE_REQUEST,
});
const userAmazonSubscribeSuccess = (entitlements: Entitlement[]): UserAction => ({
  type: UserActionTypes.USER_AMAZON_SUBSCRIBE_SUCCESS,
  entitlements,
});
const userAmazonSubscribeError = (error?: ApiError): UserAction => ({
  type: UserActionTypes.USER_AMAZON_SUBSCRIBE_ERROR,
  error,
});
export const dismissAmazonSubscribeError = () => {
  return (dispatch: Dispatch<UserAction>) => {
    dispatch(userAmazonSubscribeError());
  };
};

export const amazonSubscribe = (purchaseResponseJson: unknown) => {
  return (dispatch: ThunkDispatchType<UserAction>) => {
    return new Promise<Entitlement[]>((resolve, reject) => {
      dispatch(userAmazonSubscribeRequest());
      apiAmazonSubscribe(purchaseResponseJson)
        .pipe(concatMap(() => getEntitlements()))
        .subscribe({
          next: (res) => {
            dispatch(userAmazonSubscribeSuccess(res));
            dispatch(fetchSubscriptionSuccess(res));
            resolve(res);
          },
          error: (error) => {
            dispatch(userAmazonSubscribeError(error));
            reject(error);
          },
        });
    });
  };
};
